// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3mNsn","footer":"Form_footer__3c65A"};